import React from 'react';
import { ProjectList } from '../../components/Projects';

const Projects = () => {
  return <ProjectList />;
};

export default Projects;


